import React from 'react';
import { Card, CardBody, CardHeader, Progress } from 'reactstrap';
import Icon from 'components/Icon';

interface DeviceStatusCardProps {
  total: number;
  online: number;
  active: number;
  inactive: number;
  isLoading?: boolean;
}

const DeviceStatusCard = ({
  total,
  online,
  active,
  inactive,
  isLoading = false
}: DeviceStatusCardProps) => {
  const onlinePercentage = total > 0 ? Math.round((online / total) * 100) : 0;
  const activePercentage = total > 0 ? Math.round((active / total) * 100) : 0;

  return (
    <Card className="border-0 shadow-sm h-100">
      <CardHeader className="bg-white border-0 pt-4 pb-2">
        <h5 className="mb-0 fw-bold">
          <Icon icon="laptop" className="me-2 text-primary" />
          Status dos Dispositivos
        </h5>
      </CardHeader>
      <CardBody>
        <div className="mb-4">
          <div className="d-flex justify-content-between mb-2">
            <span className="text-muted small">Dispositivos Online</span>
            <span className="fw-bold text-success">
              {online}/{total} ({onlinePercentage}%)
            </span>
          </div>
          <Progress
            value={onlinePercentage}
            color="success"
            className="mb-0"
            style={{ height: '8px' }}
          />
        </div>

        <div className="mb-4">
          <div className="d-flex justify-content-between mb-2">
            <span className="text-muted small">Dispositivos Ativos</span>
            <span className="fw-bold text-primary">
              {active}/{total} ({activePercentage}%)
            </span>
          </div>
          <Progress
            value={activePercentage}
            color="primary"
            className="mb-0"
            style={{ height: '8px' }}
          />
        </div>

        <div className="row text-center mt-4">
          <div className="col-4">
            <div className="border rounded p-3">
              <h4 className="mb-0 fw-bold text-primary">{total}</h4>
              <small className="text-muted">Total</small>
            </div>
          </div>
          <div className="col-4">
            <div className="border rounded p-3">
              <h4 className="mb-0 fw-bold text-success">{online}</h4>
              <small className="text-muted">Online</small>
            </div>
          </div>
          <div className="col-4">
            <div className="border rounded p-3">
              <h4 className="mb-0 fw-bold text-secondary">{inactive}</h4>
              <small className="text-muted">Inativos</small>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default DeviceStatusCard;
